﻿$.fn.dxCtrlPlanitiDateHeure = function custom_dxCtrlPlanitiDateHeure(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlplanitidateheure dx-ctrl");
        this.createInstance(new cdxCtrlPlanitiDateHeure(this, option));
    }
    return this;
}

window.cdxCtrlPlanitiDateHeure = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var $DivHour = null
    var $DivCalendar = null
    var dxCalendar = null;
    var $DivTitleHourInnerLibelle = null
    function mConstruit() {
        container.empty();
        container.css({ "display": "flex" })

        var lstDay = []
        option.lstDate.forEach(function (dat) {
            var newDay = dat.getFullYear() + "/" + dat.getMonth() + "/" + dat.getDate()
            if (!lstDay.contains(newDay)) lstDay.push(newDay)
        })
        var lstDayDisabled = []
        var countDate = parametre.dateNow.getFullYear() + "/" + parametre.dateNow.getMonth() + "/" + parametre.dateNow.getDate()
        while ((new Date(countDate.split("/")[0], countDate.split("/")[1], countDate.split("/")[2])) < option.lstDate[option.lstDate.length - 1]) {
            if (!lstDay.contains(countDate)) lstDayDisabled.push(countDate)
            countDate = new Date(countDate.split("/")[0], countDate.split("/")[1], countDate.split("/")[2]).addDays(1)
            countDate = countDate.getFullYear() + "/" + countDate.getMonth() + "/" + countDate.getDate()
        }
        if (dateRefHour != null) {
            if (!lstDay.contains(dateRefHour.getFullYear() + "/" + dateRefHour.getMonth() + "/" + dateRefHour.getDate()))dateRefHour=null
        }
        lstDay.forEach(function (dat, idx) { lstDay[idx] = new Date(dat.split("/")[0], dat.split("/")[1], dat.split("/")[2]) })
        lstDayDisabled.forEach(function (dat, idx) { lstDayDisabled[idx] = new Date(dat.split("/")[0], dat.split("/")[1], dat.split("/")[2]) })

        $DivCalendar = $("<div style='display:inline-block;width:100%;' class='dx-theme-border-color-as-background-color'/>").appendTo(container)
        var $DivCalendarInner = $("<div style='position:sticky;top:0;width:100%;z-index:0;text-align:center;display:flex;justify-content:center;'/>").appendTo($DivCalendar)
        var $DivCalendarInnerInner = $("<div style='position:sticky;top:0;'/>").appendTo($DivCalendarInner)
        $("<div style='font-weight:bold;'>Choisissez la date de votre rendez-vous</div>").appendTo($DivCalendarInnerInner)
        dxCalendar = $("<div class='dx-theme-border-color-as-background-color'/>").appendTo($DivCalendarInnerInner).dxCalendar({
            firstDayOfWeek: 1,
            disabledDates: lstDayDisabled,
            value: dateRefHour,
            min: option.lstDate[0],
            width: 310,
            height: 280,
            max: option.lstDate[option.lstDate.length - 1],
            cellTemplate: function (itemData) {
                if (itemData.view === 'month' && !itemData.date) {
                    return `<span style=''>${itemData.text}</span>`;
                } else {
                    return `<span style='font-weight:bold;font-size:120%;'>${itemData.text}</span>`;
                }
            },
            onValueChanged: function (e) {
                if (e.value != null) mShowHours(e.value)
            }
        }).dxCalendar("instance")

        $DivHour = $("<div style='display:inline-block;' class='dx-theme-border-color-as-background-color'/>").appendTo(container)
        var $DivTitleHour = $("<div style='position:sticky;top:0;z-index:1;' class='dx-theme-border-color-as-background-color'/>").appendTo($DivHour)
        var $DivTitleHourInner = $("<div style='position:relative;'/>").appendTo($DivTitleHour)
        $("<div style='position:absolute;top:0;left:0;z-index:1;'/>").appendTo($DivTitleHourInner).dxCtrlButton({
            icon: "fas fa-arrow-left",
            onClick: function (e) {
                dateRefHour = null
                dxCalendar.option("value", null)
                dxPlanitHeure.element().remove()
                dxPlanitHeure = null
                $DivHour.hide()
                $DivCalendar.fadeIn(200)
                if (typeof option.dxScroll != 'undefined' && option.dxScroll != null) option.dxScroll.update()
            }
        }).dxCtrlButton("instance")
        $DivTitleHourInnerLibelle = $("<div style='width:100%;text-align:center;'/> ").appendTo($DivTitleHourInner)
        resizeObserver.mAdd(container, function () {
            mResize()
        })
        mResize()

        if (dateRefHour!= null) mShowHours(dateRefHour)
    }

    var pointBreak = 545
    function mResize() {
        if (container.innerWidth() < pointBreak) {
            $DivCalendar.css({ width: "100%" })
            if (dxPlanitHeure) {
                $DivHour.css({
                    "width": "100%",
                    "left": "0"
                })
                $DivHour.show()
                $DivCalendar.hide()
            } else {
                $DivHour.hide()
                $DivCalendar.show()
            }
        } else {
            if (dxPlanitHeure) {
                $DivCalendar.css({
                    width: "calc(100% - 250px)"
                })
                $DivHour.css({
                    "width": "250px",
                    left: "calc(100% - 250px)"
                })
                $DivCalendar.show()
                $DivHour.show()
            } else {
                $DivCalendar.css({
                    width: "100%"
                })
                $DivCalendar.show()
                $DivHour.hide()
            }
        }
    }

    var dateRefHour = null
    var dxPlanitHeure = null
    function mShowHours(datRef) {
        dateRefHour = datRef
        var lstHours = option.lstDate.filter(function (dat) { return dat.getFullYear() == datRef.getFullYear() && dat.getMonth() == datRef.getMonth() && dat.getDate() == datRef.getDate() })
        if (dxPlanitHeure != null) {
            dxPlanitHeure.element().remove()
        }

        $DivTitleHourInnerLibelle.empty()
        $("<div>" + DevExpress.localization.formatDate(datRef, "eeee d MMMM yyyy") + "</div>").appendTo($DivTitleHourInnerLibelle)
        $("<div style='font-weight:bold;'>Choisissez votre créneaux</div>").appendTo($DivTitleHourInnerLibelle)

        dxPlanitHeure = $("<div/>").appendTo($DivHour).dxCtrlPlanitiHeure({
            isInterne:option.isInterne,
            lstHours: lstHours,
            onClickDate: option.onClickDate
        }).dxCtrlPlanitiHeure("instance")

        $DivHour.show()
        if (container.innerWidth() < pointBreak) {
            $DivCalendar.hide()
            $DivHour.fadeIn(200)
        } else {
            $DivHour.animate({ width: "250px" }, 200)
            $DivCalendar.animate({ width: "calc(100% - 250px)" }, 200)
        }
        if (typeof option.dxScroll != 'undefined' && option.dxScroll != null) option.dxScroll.update()
    }

    this.mReload = function () { mConstruit() }

    this.element = function () { return container; }

    mConstruit();
}